import {authHeader} from '../backend'
import {handleResponse} from './handleResponse'
import fileSaver from 'file-saver'

export const gcsService = {
  getSummaryGcsData,
  getTemperatureRealTime,
  getTemperaturePeriod,
  getTemperaturePeriodExcelDownload,
  getAplCommBattery,
  getPinRealTime,
  getPinPeriod
}

function getSummaryGcsData (ccode) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/gcs/summary?ccode=${ccode}&` + Date.now(), requestOptions).then(handleResponse)
}

function getTemperatureRealTime (ccode, courseId) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/gcs/temperature/real-time?ccode=${ccode}&courseId=${courseId}&` + Date.now(), requestOptions).then(handleResponse)
}

function getTemperaturePeriod (ccode, courseId, sdate, edate) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/gcs/temperature/period?ccode=${ccode}&sDate=${sdate}&eDate=${edate}&courseId=${courseId}&` + Date.now(), requestOptions).then(handleResponse)
}

function getTemperaturePeriodExcelDownload (ccode, courseId, sdate, edate) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/gcs/temperature/period/excel?ccode=${ccode}&sDate=${sdate}&eDate=${edate}&courseId=${courseId}&` + Date.now(), requestOptions).then(handleResponseExcelDownload)
}

function getAplCommBattery (ccode) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/gcs/apl-comm-battery?ccode=${ccode}&` + Date.now(), requestOptions).then(handleResponse)
}

function getPinRealTime (ccode, hlidx) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/gcs/pin/real-time?ccode=${ccode}&hlidx=${hlidx}&` + Date.now(), requestOptions).then(handleResponse)
}

function getPinPeriod (ccode, hlidx, sDate, eDate) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/gcs/pin/period?ccode=${ccode}&hlidx=${hlidx}&sDate=${sDate}&eDate=${eDate}&` + Date.now(), requestOptions).then(handleResponse)
}

function handleResponseExcelDownload (response) {
  return response.blob().then(blob => fileSaver(blob, '기간별 그린 온도.xlsx'))
}



// WEBPACK FOOTER //
// ./src/router/gcsRouter.js